/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSech } from '../../factoriesAny.js';
export var sechDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createSech
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSech.generated.js
// module id = 1466
// module chunks = 2